import { Button, Dialog, DialogBody, DialogFooter, DialogHeader, Drawer, Input, Typography } from '@material-tailwind/react';
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { MapIcon, MegaphoneIcon, Squares2X2Icon } from '@heroicons/react/24/solid';

function Dashboard() {
   const [openLeft, setOpenLeft] = useState(false)

   const openDrawerLeft = () => setOpenLeft(true);
   const closeDrawerLeft = () => setOpenLeft(false);

   const contentSidebar = (
      <>
         <div className="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800">
            <Link to="#" className={`flex items-center ps-2.5 mb-5 pb-2 border-b-2 ${openLeft ? 'block' : 'hidden'}`}>
               <img src="/LogoLanscape.png" className="h-8 me-3 sm:h-7" alt="Logo RealJob" />
            </Link>
            <ul className="space-y-2 font-medium">
               <li>
                  <Link to="#" className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                     <Squares2X2Icon className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                     <span className="ms-3">Dashboard</span>
                  </Link>
               </li>
               <li>
                  <Link to="#" className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                     <Squares2X2Icon className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                     <span className="ms-3">Keluar</span>
                  </Link>
               </li>
            </ul>
         </div>
      </>
   )

   const [open, setOpen] = useState(false)
   const handleOpen = () => setOpen(!open)

   const [openDel, setOpenDel] = useState(false)
   const handleOpenDel = () => setOpenDel(!openDel)

   const dialogEdit = (
      <>
         <Dialog open={open} handler={handleOpen}>
            <DialogHeader>Its a simple dialog.</DialogHeader>
            <DialogBody className='h-[25rem] overflow-y-scroll'>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Logo Company</Typography>
                  <img src="https://www.wikipedia.org/portal/wikipedia.org/assets/img/Wikipedia-logo-v2.png" alt="" srcset="" className='h-20 mb-4' />
                  <Input
                     size="lg"
                     placeholder="https://www.wikipedia.org/portal/wikipedia.org/assets/img/Wikipedia-logo-v2.png"
                     className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                     labelProps={{
                        className: "before:content-none after:content-none",
                     }}
                  />
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Position Job</Typography>
                  <Input
                     size="lg"
                     placeholder="React Developer"
                     className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                     labelProps={{
                        className: "before:content-none after:content-none",
                     }}
                  />
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Name Company</Typography>
                  <Input
                     size="lg"
                     placeholder="Google"
                     className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                     labelProps={{
                        className: "before:content-none after:content-none",
                     }}
                  />
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Type Job</Typography>
                  <div className='grid gap-2'>
                     <Input
                        size="lg"
                        placeholder="hybrid"
                        className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                           className: "before:content-none after:content-none",
                        }}
                     />
                     <Input
                        size="lg"
                        placeholder="hybrid"
                        className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                           className: "before:content-none after:content-none",
                        }}
                     />
                     <Input
                        size="lg"
                        placeholder="hybrid"
                        className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                           className: "before:content-none after:content-none",
                        }}
                     />
                     <Input
                        size="lg"
                        placeholder="hybrid"
                        className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                           className: "before:content-none after:content-none",
                        }}
                     />
                  </div>
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Deskripsi Job</Typography>
                  <Input
                     size="lg"
                     placeholder="Bla bla ...."
                     className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                     labelProps={{
                        className: "before:content-none after:content-none",
                     }}
                  />
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Regquirement Job</Typography>
                  <Input
                     size="lg"
                     placeholder="Bla bla ...."
                     className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                     labelProps={{
                        className: "before:content-none after:content-none",
                     }}
                  />
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Salary</Typography>
                  <div className='flex items-center'>
                     <Input
                        size="lg"
                        placeholder="20.000.000"
                        className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                           className: "before:content-none after:content-none",
                        }}
                     />
                     <span className='mx-5'> - </span>
                     <Input
                        size="lg"
                        placeholder="20.000.000"
                        className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                        labelProps={{
                           className: "before:content-none after:content-none",
                        }}
                     />
                  </div>
               </div>

            </DialogBody>
            <DialogFooter>
               <Button
                  variant="text"
                  color="red"
                  onClick={handleOpen}
                  className="mr-1"
               >
                  <span>Cancel</span>
               </Button>
               <Button variant="gradient" color="green" onClick={handleOpen}>
                  <span>Save</span>
               </Button>
            </DialogFooter>
         </Dialog>
      </>
   )

   const dialogDelete = (
      <>
         <Dialog open={openDel} handler={handleOpenDel}>
            <DialogHeader>Its a simple dialog.</DialogHeader>
            <DialogBody className='h-[25rem] overflow-y-scroll'>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Logo Company</Typography>
                  <img src="https://www.wikipedia.org/portal/wikipedia.org/assets/img/Wikipedia-logo-v2.png" alt="" srcset="" className='h-20 mb-4' />
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Position Job</Typography>
                  <Typography variant='small' color='blue-gray'>React Dev</Typography>
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Name Company</Typography>
                  <Typography variant='small' color='blue-gray'>Google</Typography>
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Type Job</Typography>
                  <div className='grid gap-2 ml-1'>
                     <Typography variant='small' color='blue-gray'>Heybrid</Typography>
                     <Typography variant='small' color='blue-gray'>Heybrid</Typography>
                     <Typography variant='small' color='blue-gray'>Heybrid</Typography>
                     <Typography variant='small' color='blue-gray'>Heybrid</Typography>
                  </div>
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Deskripsi Job</Typography>
                  <Typography variant='small' color='blue-gray'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veritatis, facilis!</Typography>
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Regquirement Job</Typography>
                  <Typography variant='small' color='blue-gray'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veritatis, facilis!</Typography>
               </div>
               <div className='mb-5'>
                  <Typography variant="h6" color="blue-gray" className="mb-2"> Salary</Typography>
                  <div className='flex items-center ml-1'>
                     <Typography variant='small' color='blue-gray'>20.000</Typography>
                     <span className='mx-5'> - </span>
                     <Typography variant='small' color='blue-gray'>100.000</Typography>
                  </div>
               </div>

            </DialogBody>
            <DialogFooter>
               <Button
                  variant="text"
                  color="red"
                  onClick={handleOpenDel}
                  className="mr-1"
               >
                  <span>Cancel</span>
               </Button>
               <Button variant="gradient" color="red" onClick={handleOpenDel}>
                  <span>Delete</span>
               </Button>
            </DialogFooter>
         </Dialog>
      </>
   )

   return (
      <>
         <nav className="fixed top-0 z-50 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
            <div className="px-3 py-3 lg:px-5 lg:pl-3">
               <div className="flex items-center justify-between">
                  <div className="flex items-center justify-start rtl:justify-end">
                     <button onClick={openDrawerLeft} className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
                        <span className="sr-only">Open sidebar</span>
                        <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                           <path clip-rule="evenodd" fill-rule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
                        </svg>
                     </button>
                     <Link to="/" className="flex ms-2 md:me-24">
                        <img src="/LogoLanscape.png" className="h-8 me-3" alt="Logo RealJob" />
                     </Link>
                  </div>
                  <div className="flex items-center">
                     <div className="flex items-center ms-3">
                        <div>
                           <button type="button" className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600" aria-expanded="false" data-dropdown-toggle="dropdown-user">
                              <span className="sr-only">Open user menu</span>
                              <img className="w-8 h-8 rounded-full" src="https://flowbite.com/docs/images/people/profile-picture-5.jpg" alt="user" />
                           </button>
                        </div>
                        <div className="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600" id="dropdown-user">
                           <div className="px-4 py-3" role="none">
                              <p className="text-sm text-gray-900 dark:text-white" role="none">
                                 Neil Sims
                              </p>
                              <p className="text-sm font-medium text-gray-900 truncate dark:text-gray-300" role="none">
                                 neil.sims@flowbite.com
                              </p>
                           </div>
                           <ul className="py-1" role="none">
                              <li>
                                 <Link to="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Dashboard</Link>
                              </li>
                              <li>
                                 <Link to="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Settings</Link>
                              </li>
                              <li>
                                 <Link to="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Earnings</Link>
                              </li>
                              <li>
                                 <Link to="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Sign out</Link>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </nav>

         <Drawer placement="left" open={openLeft} onClose={closeDrawerLeft}>{contentSidebar}</Drawer>

         <aside className="fixed top-0 left-0 z-40 w-64 h-screen pt-12 transition-transform -translate-x-full bg-white border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700" aria-label="Sidebar">
            {contentSidebar}
         </aside>

         <div className="p-4 sm:ml-64">
            <div className="p-4 border-2 border-gray-200 border-dashed rounded-lg dark:border-gray-700 mt-14">


               <div className="grid sm:grid-cols-2 grid-cols-1 gap-4 mb-4">
                  <div class="p-4 bg-white shadow-lg rounded dark:bg-gray-800">
                     <div class="flex items-center">
                        <MegaphoneIcon className='w-5' />
                        <p class="ml-2 text-gray-700 text-md dark:text-gray-50">
                           Total Loker
                        </p>
                     </div>
                     <div class="flex flex-col justify-start">
                        <p class="mt-4 text-4xl font-bold text-left text-gray-800 dark:text-white">
                           36
                        </p>
                     </div>
                  </div>
                  <div class="p-4 bg-white shadow-lg rounded dark:bg-gray-800">
                     <div class="flex items-center">
                        <MegaphoneIcon className='w-5' />
                        <p class="ml-2 text-gray-700 text-md dark:text-gray-50">
                           Loker Tersedia
                        </p>
                     </div>
                     <div class="flex flex-col justify-start">
                        <p class="mt-4 text-4xl font-bold text-left text-gray-800 dark:text-white">
                           36
                        </p>
                     </div>
                  </div>
               </div>


               <div className="mb-4 py-7 rounded bg-white-50 dark:bg-gray-800">

                  <Typography variant='h2'>Daftar Loker</Typography>


                  <div className='p-4 bg-white border shadow-lg rounded dark:bg-gray-800'>
                     <div className='md:flex gap-5'>
                        <div className='grow'>
                           <div className='md:flex'>
                              <img src="1.png" alt="" srcset="" className='h-1/3 mb-4' />
                              <div className='grow'>
                                 <div className='flex gap-3 items-end mb-3 border-b'>
                                    <Typography variant='h4'>React Dev</Typography>
                                    <Typography variant='h6'>@ Gpploe</Typography>
                                 </div>
                                 <div className='grid grid-cols-2 md:grid-cols-6 gap-4 mb-3'>
                                    <div className="flex ">
                                       <MapIcon className="w-6 text-gray-200 dark:text-gray-200" />
                                       <Typography variant="small">Onsite</Typography>
                                    </div>
                                    <div className="flex ">
                                       <MapIcon className="w-6 text-gray-200 dark:text-gray-200" />
                                       <Typography variant="small">Onsite</Typography>
                                    </div>
                                    <div className="flex ">
                                       <MapIcon className="w-6 text-gray-200 dark:text-gray-200" />
                                       <Typography variant="small">Onsite</Typography>
                                    </div>
                                    <div className="flex ">
                                       <MapIcon className="w-6 text-gray-200 dark:text-gray-200" />
                                       <Typography variant="small">Onsite</Typography>
                                    </div>
                                 </div>

                              </div>
                           </div>

                           <div className="mb-3">
                              <Typography variant="h6">Deskripsi </Typography>
                              <Typography variant='small'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium, inventore.</Typography>
                           </div>

                           <div className="mb-3">
                              <Typography variant="h6">Kualifikasi </Typography>
                              <Typography variant='small'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium, inventore.</Typography>
                           </div>

                           <div className="mb-4">
                              <Typography variant="h6">Salary </Typography>
                              <Typography variant='small'>10.000 - 12.000</Typography>
                           </div>

                        </div>
                        <div className='flex md:flex-col gap-4'>
                           <Button className='grow md:grow-0' onClick={handleOpen}>edit</Button>
                           <Button className='grow md:grow-0' onClick={handleOpenDel}>hapus</Button>
                        </div>
                     </div>
                  </div>

               </div>

            </div>
         </div>

         {dialogEdit}
         {dialogDelete}

      </>
   )
}

export default Dashboard